import { createContextStore } from "@faire/web/ui/hooks/ContextStore";
import { StepPage } from "../view/step";
var INITIAL_STATE = {
  currentStep: 1,
  currentPage: StepPage.TOPIC_SELECTION,
  hasLevelQueryParams: false
};
var _createContextStore = createContextStore(INITIAL_STATE),
  useNavigationStore = _createContextStore.useStore,
  NavigationProvider = _createContextStore.Provider;
export { NavigationProvider, useNavigationStore };